import React, { useState, useEffect, useContext } from 'react';
import Message from '../documentation/Message';
import Spinner from '../documentation/Spinner';
import useApi from '../api';
import { ConversationProps, MessageType, AssistantRequest, AssistantResponse, ExistingChatProps } from '../types';
import { log } from 'console';
import { useNavigate } from 'react-router-dom';

interface ChatProps {
    chatId: string | null;
}

const Chat: React.FC<ChatProps> = ({ chatId }) => {
    const [loading, setLoading] = useState(false);
    const [userInput, setUserInput] = useState('');
    const [messages, setMessages] = useState<MessageType[]>([]);
    const [conversationId, setConversationId] = useState('');
    const [assistantResponse, setAssistantResponse] = useState('');

    const { get, getStream, post, postStream, put, patch, remove } = useApi();

    const navigate = useNavigate();

    const chatRef = React.useRef<HTMLDivElement | null>(null);

    const messagesRef = React.useRef<MessageType[]>(messages);
    messagesRef.current = messages;

    const assistantResponseRef = React.useRef(assistantResponse);
    assistantResponseRef.current = assistantResponse;

    const scrollToBottom = () => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    };

    useEffect(() => {

        scrollToBottom();

    }, [loading]);


    // Get conversation based on document id
    useEffect(() => {

        const getConversation = async (chatId: any) => {

            try {
                setLoading(true);

                let response;

                response = await get(`/sessions/${chatId}`);      

                setMessages(response.data.messages);

                setConversationId(response.data.id);

            } catch (error) {
                console.error('Error fetching conversation:', error);
            }
            setLoading(false);
        };

        getConversation(chatId);
    }, []);

    // Scroll to bottom when conversationId changes or when messages are updated
    useEffect(() => {
        scrollToBottom();
    }, [conversationId, assistantResponse]);


    return (
        <div className={`relative flex w-full shadow-lg bg-gray-50 z-20 transition-all duration-20 dark:bg-slate-800`}>
                <div className="flex flex-col h-full w-full max-h-[calc(100vh-1px)]">
                    <div ref={chatRef} className="flex flex-col h-full max-h-[calc(100vh-1px)] w-full grow items-center overflow-y-auto scrollbar-thin">
                        <div className="p-4 pb-16 mb-4 w-full justify-center grow max-w-6xl items-start">
                            {messages
                                .sort((a, b) => {
                                    const dateA = new Date(a.created_at.endsWith('Z') ? a.created_at : `${a.created_at}Z`);
                                    const dateB = new Date(b.created_at.endsWith('Z') ? b.created_at : `${b.created_at}Z`);
                                    return dateA.getTime() - dateB.getTime();
                                })
                                .map((message, index) => (
                                    <Message
                                        key={index}
                                        role={message.role}
                                        content={message.content}
                                        created_at={message.created_at}
                                    />
                                ))}
                            {assistantResponseRef.current && <Message role="assistant" content={assistantResponseRef.current} />}
                            {loading && <Spinner />}
                        </div>
                    </div>
                    {/* <div className="sticky bottom-0 z-20 shadow-l bg-gray-50 border-t p-6">
                        <div className='mx-auto flex flex-row'>
                            <div className="relative flex w-full h-12 rounded-xl bg-white border">
                                <input
                                    className="h-full w-full border-0 text-sm text-gray-700 pr-2 focus:outline-none focus:ring-1 rounded-l-xl focus:ring-blue-200 focus:border-transparent"
                                    type="text"
                                    id="search"
                                    placeholder="Type your message..."
                                    value={userInput}
                                    onChange={(e) => setUserInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            sendMessage();
                                            setUserInput('');
                                        }
                                    }}
                                />
                                <div onClick={() => { sendMessage(); setUserInput(''); }} className="grid place-items-center h-full w-12 text-gray-300 bg-blue-200 hover:bg-blue-500 text-white rounded-r-xl">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div> */}

                </div>
        </div>
    );
};

export default Chat;